import React from "react";

                                      
function SprintTaskDetails({ task, onClose, openChart, colourBlindMode }) {
  const getPriorityBackgroundColor = (colourBlindMode, priority) => {
        if (colourBlindMode === true) {
            switch (priority) {
                case 1:
                    return "bg-[#A2E365]";
                case 2:
                    return "bg-[#F3F38B]";
                case 3:
                    return "bg-[#D27D23]";
                default:
                    return "bg-[#C96514]";
            }
        }
        else {
            switch (priority) {
                case 1:
                    return "bg-[#00FF19]";
                case 2:
                    return "bg-[#DDFF0A]";
                case 3:
                    return "bg-[#FA632D]";
                default:
                    return "bg-[#ff3528]";
            }
        }
      };

  const next = () => {
    onClose();
    openChart(task);
  };

  return (
    // not responsive yet

    <div className="block fixed z-[1] w-full h-full overflow-auto bg-[rgba(0,0,0,0.649)] left-0 top-0">
      {/* modal content */}
      <div className="flex justify-center items-center mt-[25vh] ml-[60vh] w-[1250px]">

        <div className="text-[#ffffff] w-5/12 h-auto bg-[#3D3E44] rounded-xl">
          {/* Header for Form */}
          <div className="bg-[#9B9B9B] rounded-t-xl py-3 text-3xl text-center">
            Sprint Task Details
          </div>

          {/* Buttons */}
          <div className="bg-modalbg w-full">
            <div className="flex justify-between mt-[5px]">
              <div className="pl-[10px] space-x-[10px]">
                <button className="bg-modalbg text-[10px] text-[#89898A]">
                  <i class="fa-solid fa-arrow-left mr-[5px]"></i>
                  Task details
                </button>
              </div>

              <div className="pr-[10px] space-x-[10px] flex items-center">
                <button
                  className="bg-modalbg text-[10px] text-[#89898A]"
                  onClick={next}
                >
                  Accumulation Chart
                  <i class="fa-solid fa-arrow-right ml-[5px]"></i>
                </button>
              </div>
            </div>
          </div>

          {/* Form Body */}
          <div className="bg-[#3D3E44] rounded-b-xl">
            <div>
              {/* Task Name */}
              <div className="bg-modalbg flex mt-[20px]">
                <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[57px]">
                  <label for="taskName">
                    <p className="text-[14px]">Name</p>
                  </label>
                </div>
                <div className="bg-[#616675] flex shrink-10 items-center w-full mr-[15px]">
                  <div className="pl-[5px] text-[12px] bg-[#616675] w-full">
                    <p>{task.taskName}</p>
                  </div>
                </div>
              </div>

              {/* Type */}
              <div className="bg-modalbg flex mt-[10px]">
                <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[66px]">
                  <label for="taskType">
                    <p className="text-[14px]">Type</p>
                  </label>
                </div>

                {task.taskType === "Bug" && (
                  <div className="bg-modalbg flex shrink-10 items-center mr-[10px] space-x-[15px]">
                    <div className="flex items-center space-x-[2px]">
                      <div className="w-[14px] h-[13px] bg-[#616675] flex items-center justify-center">
                        <i class="fa-solid fa-check"></i>
                      </div>
                      <label for="bugType">
                        <p className="text-[10px] pt-[1px]">Bug</p>
                      </label>
                    </div>
                    <div className="flex items-center space-x-[2px]">
                      <div className="w-[14px] h-[13px] bg-[#616675]"></div>
                      <label for="defaultType">
                        <p className="text-[10px] pt-[1px]">Default</p>
                      </label>
                    </div>
                  </div>
                )}

                {task.taskType === "Default Story" && (
                  <div className="bg-modalbg flex shrink-10 items-center mr-[10px] space-x-[15px]">
                    <div className="flex items-center space-x-[2px]">
                      <div className="w-[14px] h-[13px] bg-[#616675] ">
                      </div>
                      <label for="bugType">
                        <p className="text-[10px] pt-[1px]">Bug</p>
                      </label>
                    </div>
                    <div className="flex items-center space-x-[2px]">
                      <div className="w-[14px] h-[13px] bg-[#616675] flex items-center justify-center">
                        <i class="fa-solid fa-check"></i>
                      </div>
                      <label for="defaultType">
                        <p className="text-[10px] pt-[1px]">Default</p>
                      </label>
                    </div>
                  </div>
                )}

              </div>

              {/* Story Point */}
              <div className="bg-modalbg flex mt-[10px]">
                <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[25px]">
                  <p className="text-[14px]">Story Point</p>
                </div>

                <div className="bg-[#616675] flex shrink-10 justify-center items-center w-1/12 mr-[15px]">
                  <div className="text-[12px] bg-[#616675] w-full h-full pl-[17px]">
                    <p>{task.taskStoryPoint}</p>
                  </div>
                </div>
              </div>

              {/* Tag */}
              <div className="bg-modalbg flex mt-[10px]">
                <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[72px]">
                  <label for="taskTag">
                    <p className="text-[14px]">Tag</p>
                  </label>
                </div>
                <div className="bg-[#616675] flex shrink-10 items-center w-full mr-[15px]">
                  <p className="pl-[5px] text-[12px]">{Object.values(task.taskTag).join(" | ")}</p>
                </div>
              </div>

              {/* Priority */}
              <div className="bg-modalbg flex mt-[10px]">
                <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[51.5px]">
                  <label for="taskPriority">
                    <p className="text-[14px]">Priority</p>
                  </label>
                </div>

                {task.taskPriority === 1 && (
                  <div className="bg-modalbg flex items-center mr-[10px] space-x-[10px]">
                    <div className="flex items-center space-x-[2px] mr-[5px]">
                      <div className={`${getPriorityBackgroundColor(colourBlindMode, 1)} w-[14px] h-[13px] flex items-center justify-center`}><i class="fa-solid fa-check  text-black"></i></div>
                      <label for="priorityLow">
                        <p className="text-[10px]">Low</p>
                      </label>
                    </div>
                    <div className="flex items-center space-x-[2px]">
                      <div className={`${getPriorityBackgroundColor(colourBlindMode, 2)} w-[14px] h-[13px] flex items-center justify-center`}></div>
                      <label for="priorityMedium">
                        <p className="text-[10px]">Medium</p>
                      </label>
                    </div>

                    <div className="flex items-center space-x-[2px]">
                      <div className={`${getPriorityBackgroundColor(colourBlindMode, 3)} w-[14px] h-[13px] flex items-center justify-center`}></div>
                      <label for="priorityImportant">
                        <p className="text-[10px]">Important</p>
                      </label>
                    </div>

                    <div className="flex items-center space-x-[2px]">
                      <div className={`${getPriorityBackgroundColor(colourBlindMode, 4)} w-[14px] h-[13px] flex items-center justify-center`}></div>
                      <label for="priorityUrgent">
                        <p className="text-[10px]">Urgent</p>
                      </label>
                    </div>
                  </div>
                )}


                {task.taskPriority === 2 && (
                  <div className="bg-modalbg flex items-center mr-[10px] space-x-[10px]">
                    <div className="flex items-center space-x-[2px] mr-[5px]">
                      <div className={`${getPriorityBackgroundColor(colourBlindMode, 1)} w-[14px] h-[13px] flex items-center justify-center`}></div>
                      <label for="priorityLow">
                        <p className="text-[10px]">Low</p>
                      </label>
                    </div>
                    <div className="flex items-center space-x-[2px]">
                      <div className={`${getPriorityBackgroundColor(colourBlindMode, 2)} w-[14px] h-[13px] flex items-center justify-center`}><i class="fa-solid fa-check text-black"></i></div>
                      <label for="priorityMedium">
                        <p className="text-[10px]">Medium</p>
                      </label>
                    </div>

                    <div className="flex items-center space-x-[2px]">
                      <div className={`${getPriorityBackgroundColor(colourBlindMode, 3)} w-[14px] h-[13px] flex items-center justify-center`}>
                      </div>
                      <label for="priorityImportant">
                        <p className="text-[10px]">Important</p>
                      </label>
                    </div>

                    <div className="flex items-center space-x-[2px]">
                      <div className={`${getPriorityBackgroundColor(colourBlindMode, 4)} w-[14px] h-[13px] flex items-center justify-center`}></div>
                      <label for="priorityUrgent">
                        <p className="text-[10px]">Urgent</p>
                      </label>
                    </div>
                  </div>
                )}

                {task.taskPriority === 3 && (
                  <div className="bg-modalbg flex items-center mr-[10px] space-x-[10px]">
                    <div className="flex items-center space-x-[2px] mr-[5px]">
                      <div className={`${getPriorityBackgroundColor(colourBlindMode, 1)} w-[14px] h-[13px] flex items-center justify-center`}></div>
                      <label for="priorityLow">
                        <p className="text-[10px]">Low</p>
                      </label>
                    </div>
                    <div className="flex items-center space-x-[2px]">
                      <div className={`${getPriorityBackgroundColor(colourBlindMode, 2)} w-[14px] h-[13px] flex items-center justify-center`}></div>
                      <label for="priorityMedium">
                        <p className="text-[10px]">Medium</p>
                      </label>
                    </div>

                    <div className="flex items-center space-x-[2px]">
                      <div className={`${getPriorityBackgroundColor(colourBlindMode, 3)} w-[14px] h-[13px] flex items-center justify-center`}><i class="fa-solid fa-check  text-black"></i>
                      </div>
                      <label for="priorityImportant">
                        <p className="text-[10px]">Important</p>
                      </label>
                    </div>

                    <div className="flex items-center space-x-[2px]">
                      <div className={`${getPriorityBackgroundColor(colourBlindMode, 4)} w-[14px] h-[13px] flex items-center justify-center`}></div>
                      <label for="priorityUrgent">
                        <p className="text-[10px]">Urgent</p>
                      </label>
                    </div>
                  </div>
                )}

                {task.taskPriority === 4 && (
                  <div className="bg-modalbg flex items-center mr-[10px] space-x-[10px]">
                    <div className="flex items-center space-x-[2px] mr-[5px]">
                      <div className={`${getPriorityBackgroundColor(colourBlindMode, 1)} w-[14px] h-[13px] flex items-center justify-center`}></div>
                      <label for="priorityLow">
                        <p className="text-[10px]">Low</p>
                      </label>
                    </div>
                    <div className="flex items-center space-x-[2px]">
                      <div className={`${getPriorityBackgroundColor(colourBlindMode, 2)} w-[14px] h-[13px] flex items-center justify-center`}></div>
                      <label for="priorityMedium">
                        <p className="text-[10px]">Medium</p>
                      </label>
                    </div>

                    <div className="flex items-center space-x-[2px]">
                      <div className={`${getPriorityBackgroundColor(colourBlindMode, 3)} w-[14px] h-[13px] flex items-center justify-center`}>
                      </div>
                      <label for="priorityImportant">
                        <p className="text-[10px]">Important</p>
                      </label>
                    </div>

                    <div className="flex items-center space-x-[2px]">
                      <div className={`${getPriorityBackgroundColor(colourBlindMode, 4)} w-[14px] h-[13px] flex items-center justify-center`}><i class="fa-solid fa-check  text-black"></i></div>
                      <label for="priorityUrgent">
                        <p className="text-[10px]">Urgent</p>
                      </label>
                    </div>
                  </div>
                )}
              </div>

              {/* Description */}
              <div className="bg-modalbg flex mt-[10px]">
                <div className="bg-modalbg flex justify-end items-baseline mr-[9px] pl-[21px]">
                  <label for="description">
                    <p className="text-[14px]">Description</p>
                  </label>
                </div>
                <div className="bg-[#616675] flex shrink-10 justify-top items-baseline w-full min-h-[64px] mr-[15px]">
                  <div className="pl-[5px] text-[12px] w-full h-full bg-[#616675]">
                    <p>{task.taskDescription}</p>
                  </div>
                </div>
              </div>

              {/* Status */}
              <div className="bg-modalbg flex mt-[10px]">
                <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[55px]">
                  <label for="statusTag">
                    <p className="text-[14px]">Status</p>
                  </label>
                </div>
                <div className="bg-[#616675] flex shrink-10 items-center w-full mr-[15px]">
                  <div className="w-full bg-[#616675] text-[12px] pl-[5px]">
                    {task.taskStatus}
                  </div>
                </div>
              </div>

              {/* Stage */}
              <div className="bg-modalbg flex mt-[10px]">
                <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[58px]">
                  <label for="stageTag">
                    <p className="text-[14px]">Stage</p>
                  </label>
                </div>
                <div className="bg-[#616675] flex shrink-10 items-center w-full mr-[15px]">
                  <div className="w-full bg-[#616675] text-[12px] pl-[5px]">
                    {task.taskStage}
                  </div>
                </div>
              </div>

              {/* Assignee */}
              <div className="bg-modalbg flex mt-[10px]">
                <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[31px]">
                  <label for="assignee">
                    <p className="text-[15px]">Assignee</p>
                  </label>
                </div>
                <div className="bg-[#616675] flex shrink-10 items-center w-full mr-[15px]">
                  {/* replace with the database for the assignee */}
                  <div className="w-full bg-[#616675] text-[12px] pl-[5px]">
                    {task.taskAssignee}
                  </div>
                </div>
              </div>

              {/* Log Time Spent */}
              <div className="bg-modalbg flex mt-[10px]">
                <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[7px]">
                  <label for="logSpent">
                    <p className="text-[12px]">Log Time Spent</p>
                  </label>
                </div>
                <div className="bg-[#616675] flex items-center mr-[6px] w-5/12 space-x-[15px]">
                  <div className="pl-[5px] text-[12px] h-full bg-[#616675] w-2/12">
                    {task.sprintLogTime[task.sprintLogTime.length - 1].hour}
                  </div>
                  <p className="text-[12px]">{task.sprintLogTime[task.sprintLogTime.length - 1].hour === 1 ? "Hour" : "Hours"}</p>
                </div>
                <div className="bg-[#616675] flex items-center mr-[15px] flex-auto">
                  <div className="bg-[#616675] rounded w-full text-[12px] pl-[5px]">
                    <p>{task.sprintLogTime[task.sprintLogTime.length - 1].day}</p>
                  </div>
                </div>
              </div>

              {/* Total Log Time Spent */}
              <div className="bg-modalbg flex mt-[10px]">
                <div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[12px]">
                  <label for="logTotal">
                    <p className="text-[12px]">Total Log Time</p>
                  </label>
                </div>
                <div className="bg-[#616675] flex shrink-10 items-center mr-[10px] w-5/12">
                  <p className="pl-[5px] text-[12px]">{task.sprintTotalLogTime} {task.sprintTotalLogTime === 1 ? "Hour" : "Hours"}</p>
                </div>
              </div>

              {/* Buttons */}
              <div className="bg-modalbg flex mt-[25px] justify-center mb-[20px]">
                <div className="space-x-5">
                  <button
                    className="bg-[#616675] pl-[12px] pr-[12px]"
                    onClick={onClose}
                  >
                    CLOSE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SprintTaskDetails;
